import type { BeckyFunctionLibrary, BeckyModel } from '@wix/thunderbolt-becky-root'
import { cssModelFactory } from '@wix/thunderbolt-becky-carmi-ds/dist/carmiEntries/css-entry'

export const getCarmiCss = async (beckyModel: BeckyModel, funcLib: BeckyFunctionLibrary): Promise<string> => {
	const processOoiCss = () => ''

	const carmiResults = funcLib.runAndReport(
		() =>
			cssModelFactory(beckyModel, {
				...funcLib,
				processOoiCss,
			}),
		'get-carmi-css'
	)
	return carmiResults.css
}
